import { Marker, SingleMapMarker } from 'components/map/Map';
import EventUtils from 'helper/eventUtils';
import { transformToRioPosition } from 'helper/position';
import { getVehicleIdentifier } from 'helper/vehicleV2';
import { useDispatch, useSelector } from 'react-redux';
import {
    clearSelectedVehicle,
    getSelectedVehicle,
    setFollowSelectedVehicle,
    setSelectedVehicle,
} from 'store/slices/appSlice';

import { DrivingState, type VehicleV2 } from 'API';

import './_styles.scss';

import { setMarkerColor } from './utils';

interface VehicleMarkerProps {
    vehicle: VehicleV2;
}

const VehicleMarker = ({ vehicle }: VehicleMarkerProps) => {
    const dispatch = useDispatch();
    const selectedVehicle = useSelector(getSelectedVehicle);
    const selectedVIN = selectedVehicle?.selectedVIN;
    const isSelected = selectedVIN === vehicle?.vin;
    const position = vehicle.position?.value?.position;
    const vehicleIdentifier = getVehicleIdentifier(vehicle);

    const handleClick = () => {
        if (isSelected) {
            dispatch(clearSelectedVehicle());
            return;
        }

        dispatch(setSelectedVehicle({ selectedVIN: vehicle?.vin, pvlTriggered: false }));
        dispatch(setFollowSelectedVehicle(false));
    };

    const eventListenerMap = {
        [EventUtils.TAP]: handleClick,
    };

    if (!position) {
        return null;
    }

    return (
        <Marker
            eventListenerMap={eventListenerMap}
            position={transformToRioPosition(position)}
            icon={
                <SingleMapMarker
                    fixed
                    bearing={position?.heading || undefined}
                    moving={vehicle.drivingState?.value?.state === DrivingState.DRIVING}
                    name={vehicleIdentifier}
                    iconNames={['truck']}
                    active={isSelected}
                    className={setMarkerColor(vehicle)}
                />
            }
        />
    );
};

export default VehicleMarker;
